import React, { CSSProperties } from 'react';
import type { UniqueIdentifier } from '@dnd-kit/core';
import { AnimateLayoutChanges, useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

import { TreeItem, Props as TreeItemProps } from '../SortableTree/TreeItem';

interface Props extends TreeItemProps {
  id: UniqueIdentifier;
  elementStyle: any
}

const animateLayoutChanges: AnimateLayoutChanges = ({ isSorting, wasDragging }) =>
  isSorting || wasDragging ? false : true;

export const SortableTreeItem = ({ id, depth, type, activeItemDetails, elementStyle, ...props }: Props) => {
  const {
    attributes,
    isDragging,
    isSorting,
    listeners,
    setDraggableNodeRef,
    setDroppableNodeRef,
    transform,
    transition,
  } = useSortable({
    id,
    animateLayoutChanges,
  });
  const style: CSSProperties = {
    transform: CSS.Translate.toString(transform),
    transition,
  };

  return (
    <TreeItem
      id={id}
      ref={setDraggableNodeRef}
      wrapperRef={setDroppableNodeRef}
      style={style}
      depth={depth}
      type={type}
      activeItemDetails={activeItemDetails}
      ghost={isDragging}
      disableInteraction={isSorting}
      elementStyle={elementStyle}
      handleProps={{
        ...attributes,
        ...listeners,
      }}
      {...props}
    />
  );
}

export default SortableTreeItem;